export const environment = {
  mainUrl: 'https://geonavigator-dev.cbre.com/',
  baseUrl: '/',
  articleApiUrl: 'https://geonavigator-dev.cbre.com/api-comp',
  imageUrl: 'https://geonavigator-dev.cbre.com/api-images',
  indexingApiUrl: 'https://geonavigator-dev.cbre.com/api-index',
  ondemandApiUrl: 'https://geonavigator-dev.cbre.com/api-ondemand',
  educationApiUrl: 'https://geonavigator-dev.cbre.com/api-education',
  eriApiUrl: 'https://geonavigator-dev.cbre.com/api-eri',
  blsApiUrl: 'https://geonavigator-dev.cbre.com/api-bls',
  adminUrl: 'https://geonavigator-dev.cbre.com/api-admin',
  esriSuggestApiUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest',
  competitionApiUrl: 'https://geonavigator-dev.cbre.com/api-comp',
  laborplanApiUrl: 'https://geonavigator-dev.cbre.com/api-laborplan',
  production: false,
  securityTenantName: 'cbre.onmicrosoft.com',
  securityClientId: '1d2914a7-ba45-4de1-b417-ee576e4d7b76',
  isResearch: true,
  isInterviews: true,
  INTERVIEW_API_URL: 'https://geonavigator-dev.cbre.com/api-comp',
  THOUGHTSPOT_USERNAME: 'US_SVC_LA_TS_SF_INT',
  ANALYTICS_KEY: 'e3F324y30cELUJsJcrIdz2sWP2o1LUfD',
  GLV_HOME: 'http://glv-dev.cbre.com/Home',
  puppeteerApiUrl: 'https://geonavigator-dev-api.cbre.com/api/html-screenshot?code=g_STEUSJelFErZyCsBUIXUWAK98DIJUfksUGlIvder-qAzFuWn1RFg==',
  geoskillFaqUrl: 'https://cbre.sharepoint.com/sites/intra-AdvisoryTransactionServices/SiteAssets/Forms/AllItems.aspx?id=%2Fsites%2Fintra%2DAdvisoryTransactionServices%2FSiteAssets%2FSitePages%2FAMS%2DConsulting%2FGeoSkill%5FFAQ%2Epdf&parent=%2Fsites%2Fintra%2DAdvisoryTransactionServices%2FSiteAssets%2FSitePages%2FAMS%2DConsulting',
  ANALYTICS_UUID_API: 'https://mktgservice.cbre.com/v2/uuid-generator'
};
